<ng-container *transloco="let t; prefix:'PremiseHazard'">
  <div class="page-container">
    <div class="control-container" [hidden]="listHidden">
      <app-premise-hazard-list (PremiseHazardClicked)="onPremiseHazardSelected($event)"
        (DeletePremiseHazardClicked)="onDeletePremiseHazardClicked($event)"
        (QuickEditPremiseHazardClicked)="onQuickEditPremiseHazardClicked($event)"
        (AddNewPremiseHazardClicked)="addNewPremiseHazardClicked()" [PremiseHazardTypes]="PremiseHazardTypes"
        [changeSelectedPremiseHazard]="changePremiseHazardViewSubject"
        [premiseHazardDeletedSubject]="premiseHazardDeletedSubject" [showSearch]="true"></app-premise-hazard-list>
    </div>
    <div class="item-view-container" [hidden]="!listHidden">
      <div class="control-container">
        @if (IsViewing) {
        <app-view-premise-hazard-item [PremiseHazardInput]="SelectedPremiseHazard" [CanEdit]="canEdit"
          [CanDelete]="canDelete" [CanCreateReports]="canCreateReports"
          (backClicked)="showList()" (editClicked)="onEditClicked($event)" (deleteClicked)="openDeleteConfirmDialog()"
          (printClicked)="createPremiseHazardReport()" (premiseHazardModifiedEvent)="refreshHazard()"
          (hazardReloaded)="onHazardReloaded($event)" (hazardNotFound)="onHazardNotFound($event)"
          (requestProccessing)="onViewRequest(false)" (requestCompleted)="onViewRequest(true)"
          (isSharedEvent)="setSharedHazard($event)"></app-view-premise-hazard-item>
        }
        @if (IsEditing) {
        <app-premise-hazard-item (submittedEvent)="onSubmitEvent($event)" (cancelEvent)="onCancelEvent()"
          [SelectedPremiseHazard]="SelectedPremiseHazard" [ETag]="SelectedPremiseHazardEtag"
          [PremiseHazardTypes]="PremiseHazardTypes" [Addresses]="Addresses" [IsQuickEdit]="IsQuickEdit"
          (quickEditEvent)="onQuickEditEvent($event)"></app-premise-hazard-item>
        }
      </div>
    </div>
  </div>
</ng-container>